import { useState, useCallback } from 'react';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';
/**
 * Hook para gestionar el tipo de cambio con BANXICO
 */
const useTipoCambio = (totales, setTotales) => {
    const { token, setToken } = useToken();
    const [consultandoTC, setConsultandoTC] = useState(false);
    const { showErrorToast } = useToast();
    /**
     * Obtiene el tipo de cambio de BANXICO
     */
    const obtenerBanxicoTC = useCallback(async (dateParam_ = '') => {
        console.log(dateParam_);
        console.log(totales.dFechaVenta);

        const date_ = (dateParam_ === '') 
            ? new Date(totales.dFechaVenta).toLocaleString('sv', { timeZoneName: 'short' }).substring(0, 10) 
            : new Date(dateParam_).toLocaleString('sv', { timeZoneName: 'short' }).substring(0, 10);

        const fechaVenta = (dateParam_ === '') ? totales.dFechaVenta : dateParam_;

        console.log(date_);
        setConsultandoTC(true);

        try {
            const response = await fetch(
                `https://www.banxico.org.mx/SieAPIRest/service/v1/series/SF60653/datos/${date_}/${date_}?decimales=sinCeros&token=7d0140dc6159dbe4a870c61dce8136190da8e9757776cb679483bdaaa31643e6`,
                { method: 'GET' }
            );

            if (response.ok) {
                const data = await response.json();
                console.log(data);
                console.log(data.bmx.series[0].datos[0].dato);

                setTotales(prev => ({ 
                    ...prev, 
                    vMoneda: "USD", 
                    dTipoCambio: parseFloat(data.bmx.series[0].datos[0].dato), 
                    dFechaVenta: new Date(fechaVenta) + "" 
                }));
            } else {
                
                showErrorToast(response.status + ' ' + response.statusText);
                
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
                
                // Fallback
                alert("Hubo un problema con la conexión al Banco de México, por lo que estableceremos el Tipo de Cambio a 19.555.");
                setTotales(prev => ({ 
                    ...prev, 
                    vMoneda: "USD", 
                    dTipoCambio: 19.555, 
                    dFechaVenta: new Date(fechaVenta) + "" 
                }));
            }
        } catch (error) {
            
            showErrorToast('' + error.message);
            
            // Fallback
            alert("Hubo un problema con la conexión al Banco de México, por lo que estableceremos el Tipo de Cambio a 19.555.");
            setTotales(prev => ({ 
                ...prev, 
                vMoneda: "USD", 
                dTipoCambio: 19.555, 
                dFechaVenta: new Date(fechaVenta) + "" 
            }));
            
            console.log('Hubo un problema con la peticion Fetch:' + error.message);
        } finally {
            setConsultandoTC(false);
        }
    }, [totales.dFechaVenta, setTotales, token, setToken]);


    const obtenerTipoCambio = useCallback(async (monedaDestino) => {
        console.log('[useTipoCambio] obtenerTipoCambio - monedaDestino:', monedaDestino);
        if (monedaDestino === 'USD') {
            // Para USD, usa la lógica de Banxico
            console.log('[useTipoCambio] USD: invocando obtenerBanxicoTC');
            await obtenerBanxicoTC();
            return;
        }
        setConsultandoTC(true);

        try {
            let tipoCambio = 1;
        
            console.log(
                '[useTipoCambio] Consultando tipo de cambio para',
                monedaDestino,
                'desde MXN'
            );
        
            const response = await fetch(
                'https://api.exchangerate-api.com/v4/latest/MXN'
            );
        
            const data = await response.json();
        
            const tipoCambioApi = data.rates[monedaDestino];
        
            tipoCambio =
                tipoCambioApi && tipoCambioApi > 0
                    ? 1 / tipoCambioApi
                    : 1;
        
            console.log(
                '[useTipoCambio] Tipo de cambio obtenido:',
                tipoCambio
            );
        
            setTotales(prev => ({
                ...prev,
                vMoneda: monedaDestino,
                dTipoCambio: tipoCambio,
                dFechaVenta: new Date().toISOString()
            }));
        
            console.log('[useTipoCambio] setTotales ejecutado:', {
                vMoneda: monedaDestino,
                dTipoCambio: tipoCambio
            });
        
        } catch (error) {
        
            showErrorToast('Error al obtener tipo de cambio');
        
            setTotales(prev => ({
                ...prev,
                vMoneda: monedaDestino,
                dTipoCambio: 1,
                dFechaVenta: new Date().toISOString()
            }));
        
            console.error(
                '[useTipoCambio] Error al obtener tipo de cambio:',
                error
            );
        
        } finally {
            setConsultandoTC(false);
        }
    }, [setTotales, showErrorToast, obtenerBanxicoTC]);

    return {
        consultandoTC,
        obtenerBanxicoTC,
        obtenerTipoCambio
    };
};

export default useTipoCambio;
